import { tooltipFormatter } from "./commonOptions";
import { MAX_SERVING_TEMP } from "@common/constants/chartOptions";
const chartOptions = () => ({
  animation: false,
  textStyle: {
    fontFamily: "Gotham-Medium"
  },
  tooltip: {
    trigger: "axis",
    formatter: tooltipFormatter("serving"),
    hideDelay: 5000
  },
  legend: {
    data: ["Temperature", "Predicted"],
    orient: "vertical",
    top: "10%",
    left: "left",
    zlevel: 2
  },
  grid: {
    top: 30,
    left: 35,
    right: 60,
    bottom: 30
  },
  dataZoom: {
    show: true,
    type: "inside",
    filterMode: "none"
  },
  xAxis: [
    {
      type: "time",
      name: "Time",
      splitLine: {
        show: false
      },
      axisPointer: {
        value: 0,
        triggerTooltip: false,
        lineStyle: {
          color: "#fdcc00",
          opacity: 1,
          width: 2
        },
        label: {
          show: true,
          backgroundColor: "#fdcc00",
          color: "#24262c",
          fontFamily: "Gotham-Medium",
          borderRadius: 10,
          shadowColor: "#24262c"
        },
        handle: {
          show: true,
          color: "#24262c"
        }
      }
    }
  ],
  yAxis: [
    {
      type: "value",
      scale: true,
      name: "Temp.",
      min: 0,
      max: MAX_SERVING_TEMP,
      boundaryGap: [0.2, 0.2]
    }
  ],
  series: [
    {
      name: "Actual Temperature",
      showSymbol: false,
      type: "line",
      data: [],
      smooth: true,
      areaStyle: { opacity: 0.3 },
      lineStyle: { width: 4 },
      color: ["#8dc538"],
      sampling: "average"
    },
    {
      name: "Predicted Temperature",
      connectNulls: true,
      showSymbol: false,
      type: "line",
      data: [],
      smooth: true,
      lineStyle: { width: 4, type: "dotted" },
      color: ["#F2F1EE"],
      markLine: {
        symbol: [false, "circle"],
        data: [],
        lineStyle: {
          color: "#cfcecd",
          type: "dotted"
        }
      }
    },
    {
      name: "Phases",
      showSymbol: false,
      type: "line",
      data: [],
      markLine: {
        symbol: false,
        data: [],
        lineStyle: {
          color: "#cfcecd",
          type: "solid",
          width: 2
        }
      }
    },
    {
      name: "Historic Temperature",
      showSymbol: false,
      type: "line",
      data: [],
      markLine: {
        symbol: false,
        data: [],
        lineStyle: {
          color: "#cfcecd",
          type: "solid",
          width: 2
        }
      },
      smooth: true,
      areaStyle: { opacity: 0.3 },
      lineStyle: { width: 4 },
      color: ["#8dc538"],
      sampling: "average"
    }
  ]
});
export default chartOptions;
